import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'es',
    conver: 'es-ES',
    alia: 'es',
    region: 'Spain',
    regionText: 'España',
    language: 'Spain',
    languageText: 'Español',
    appId: 11,
    acceptLanguage: 'es-ES,es;q=0.9',
};
export default theLocale;
